import { type SocietyWorkflowInstanceInvokeParamsInput } from "shared/api/types/society/[societyId]/workflow/[workflowId]/instance";
import PillarForm from "shared/components/pillar-form/PillarForm";
import PillarModalBody, {
  ModalMaxWidth,
} from "shared/components/pillar-modal/NewPillarModalBody";
import { type PillarModalControlAsync } from "shared/components/pillar-modal/usePillarModalControl";

type AdminFormSubmitModalProps = {
  control: PillarModalControlAsync<SocietyWorkflowInstanceInvokeParamsInput>;
};

const AdminFormSubmitModal = ({ control }: AdminFormSubmitModalProps) => {
  return (
    <PillarModalBody
      control={control}
      title="Admin Form Submit"
      maxW={ModalMaxWidth.Sm_500}
    >
      <div className="py-4">
        <p className="mb-4 text-subtle">
          You are submitting form as an admin. Configure how the workflow should
          behave.
        </p>

        <PillarForm<SocietyWorkflowInstanceInvokeParamsInput>
          handleSubmit={async (values) => control.resolve(values)}
        >
          <PillarForm.Checkbox
            additionalClasses="!flex-row items-center gap-x-1 pb-3"
            label="Skip sending notification emails to the user for this submission."
            name="skipEmail"
          />

          <div className="flex justify-end gap-2">
            <PillarForm.Button
              onClick={() => control.onClose()}
              className="button-regular-neutral-filled"
            >
              Cancel
            </PillarForm.Button>
            <PillarForm.LoadingSubmitButton
              label="Submit"
              testid="admin-form-modal-submit-button"
            />
          </div>
        </PillarForm>
      </div>
    </PillarModalBody>
  );
};

export default AdminFormSubmitModal;
